/**
 * Enum for retail units.
 */
export const RetailUnit = {
    /** United Arab Emirates */
    AE: 'ae',
    /** Chile */
    CL: 'cl',
    /** Colombia */
    CO: 'co',
    /** Estonia */
    EE: 'ee',
    /** Egypt */
    EG: 'eg',
    /** Israel */
    IL: 'il',
    /** Jordan */
    JO: 'jo',
    /** Kuwait */
    KW: 'kw',
    /** Lithuania */
    LT: 'lt',
    /** Latvia */
    LV: 'lv',
    /** Morocco */
    MA: 'ma',
    /** Mexico */
    MX: 'mx',
    /** Malaysia */
    MY: 'my',
    /** Netherlands */
    NL: 'nl',
    /** Oman */
    OM: 'om',
    /** Philippines */
    PH: 'ph',
    /** Qatar */
    QA: 'qa',
    /** Singapore */
    SG: 'sg',
    /** Thailand */
    TH: 'th',
};
export const isRetailUnit = (x) => Object.values(RetailUnit).includes(x);
